var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitor2th monitorPage"},[_c('MyHeader',{staticClass:"monitor-title",attrs:{"title":"协 鑫 智 算（苏 州）中 心"}}),_c('div',{staticClass:"page-center"},[_c('MyNumber'),_c('Part6',{staticClass:"mt-50"}),_c('Part7',{staticClass:"mt-50",staticStyle:{"transform":"scale(1.2)"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }